export class AnuncioSituacao {
  id: number;
  nome: string;

  constructor(id: number, nome?: string) {
    this.id = id;
    this.nome = nome;
  }
}
